"use client"
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ReactLenis } from 'lenis/react'
import { useEffect, useRef } from 'react'


export default function Scroll({ children }) {
  const lenisRef = useRef()

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger)

    function update(time) {
      lenisRef.current?.lenis?.raf(time * 1000); // Convert time from seconds to milliseconds
    }

    lenisRef.current?.lenis?.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(update);

    return () => {
      gsap.ticker.remove(update)
      lenisRef.current?.lenis?.destroy();
    }
  }, [])

  return (
    <ReactLenis root options={{ autoRaf: false }} ref={lenisRef}>{children}</ReactLenis>
  )
}